export default "__VITE_ASSET__D4dOOg1Y__"